import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon, BadgeCheckIcon } from 'lucide-react';
import { testimonials, usageCards } from '../data/content';

/**
 * Sekcja opinii.
 * Dopóki w data/content.ts nie ma zweryfikowanych, autoryzowanych opinii,
 * pokazujemy zastosowania materiałów — bez fikcyjnych cytatów, nazwisk i ocen.
 */
export function Testimonials() {
  const hasVerified = testimonials.length > 0;
  return <section className="w-full px-5 py-14 sm:py-20" data-id="element-222" data-mp="370kbgjkl6znx">
      <div className="mx-auto max-w-5xl" data-id="element-223" data-mp="3205ziqfv75km">
        <h2 className="mx-auto max-w-2xl text-center font-display text-2xl font-bold leading-tight text-ink sm:text-4xl" data-id="element-224" data-mp="31ybelc4lfdgj">
          {hasVerified ? 'Co mówią nauczyciele chemii' : 'Jak nauczyciele mogą wykorzystać Wizualną Chemię™'}
        </h2>

        <div className="mt-10 grid gap-4 sm:gap-6 md:grid-cols-3" data-id="element-225" data-mp="v9ges0lg0qvh">
          {hasVerified ? testimonials.map((t, i) => <motion.article key={`${t.name}-${t.city}`} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.2
        }} transition={{
          duration: 0.3,
          delay: i * 0.06,
          ease: [0.23, 1, 0.32, 1]
        }} className="flex flex-col rounded-2xl border border-chem/20 bg-white p-6 shadow-sm shadow-chem/5" data-id="element-226" data-mp="qbeqn195u1d5" data-mpi={i}>
                  {t.verified && <span className="inline-flex w-fit items-center gap-1.5 rounded-full bg-chem/10 px-2.5 py-1 text-[10px] font-bold uppercase tracking-[0.1em] text-chem-deep" data-id="element-227" data-mp="zxr044o4iq98">
                      <BadgeCheckIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-228" data-mp="q7eiak7p1b6s" />
                      Zweryfikowana opinia
                    </span>}

                  {t.verified && typeof t.rating === 'number' && <div className="mt-3 flex gap-0.5" aria-label={`Ocena ${t.rating} na 5`} data-id="element-229" data-mp="1itz83g8itf88">
                      {Array.from({
              length: t.rating
            }).map((_, s) => <StarIcon key={s} className="h-4 w-4 fill-chem text-chem" aria-hidden="true" data-id="element-230" data-mp="1siwcygaqts6q" data-mpi={s} />)}
                    </div>}

                  <p className="mt-4 flex-1 text-sm leading-relaxed text-ink/80" data-id="element-231" data-mp="1jkc406uziwvp">„{t.quote}”</p>

                  <div className="mt-auto pt-6" data-id="element-232" data-mp="1el7uff45ex4u">
                    <p className="text-sm font-bold text-ink" data-id="element-233" data-mp="19s6bmw0tmdfz">{t.name}</p>
                    <p className="text-xs text-ink/60" data-id="element-234" data-mp="14tblf90ixmlu">{t.city}, Polska</p>
                    <p className="text-xs italic text-chem-deep" data-id="element-235" data-mp="14r8w6r773xi6">{t.role}</p>
                  </div>
                </motion.article>) : usageCards.map((card, i) => <motion.article key={card.title} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.2
        }} transition={{
          duration: 0.3,
          delay: i * 0.06,
          ease: [0.23, 1, 0.32, 1]
        }} className="flex flex-col rounded-2xl border border-chem/20 bg-white p-6 shadow-sm shadow-chem/5" data-id="element-236" data-mp="vrvifmc1gmrn" data-mpi={i}>
                  <span className="font-display text-sm font-bold uppercase tracking-[0.14em] text-chem" data-id="element-237" data-mp="3ggylm0eq53r5">
                    {String(i + 1).padStart(2, '0')}
                  </span>
                  <h3 className="mt-3 font-display text-xl font-bold text-ink" data-id="element-238" data-mp="2op97gech51t4">{card.title}</h3>
                  <p className="mt-3 flex-1 text-sm leading-relaxed text-ink/70" data-id="element-239" data-mp="2srcnlga38ukq">
                    {card.description}
                  </p>
                </motion.article>)}
        </div>
      </div>
    </section>;
}